import React from "react";
import {
  GoogleMap,
  GoogleMapProps,
  LoadScript,
  Marker,
  MarkerProps,
  StreetViewPanorama,
} from "@react-google-maps/api";
import { IListing } from "../../lib/Listing";
import { EMapTheme, getMapTheme } from "../../lib/util";

export interface IListingMapProps {
  listing: IListing;
  zoom?: number;
  className?: string;
  titleClassName?: string;
  title?: string;
  mapApiKey?: string;
  mapId?: string;
  googleMapsProps?: Partial<GoogleMapProps>;
  mapTheme?: EMapTheme;
  markerProps?: Partial<MarkerProps>;
  streetView?: boolean;
}

export const ListingMap: React.FC<IListingMapProps> = ({
  listing,
  zoom = 12,
  className,
  titleClassName = "",
  title,
  mapApiKey = "AIzaSyBSypNhQTAdXM5ua2lx93n2Cwso-Rgra4w",
  mapId,
  googleMapsProps,
  mapTheme = EMapTheme.standard,
  markerProps,
  streetView = false,
}) => {
  const loc: google.maps.LatLngLiteral = {
    lat: listing.location?.lat || 0,
    lng: listing.location?.lng || 0,
  };
  const theme = getMapTheme(mapTheme);
  return (
    <div className={`${className} listing-map`}>
      {title && <h2 className={`text-h2-text ${titleClassName}`}>{title}</h2>}
      {listing.location && (
        <div>
          {!streetView ? (
            <LoadScript googleMapsApiKey={mapApiKey}>
              <GoogleMap
                center={loc}
                mapContainerStyle={{
                  width: "100%",
                  height: "60vh",
                }}
                zoom={zoom}
                options={{ mapId: mapId, styles: theme }}
                {...googleMapsProps}
              >
                <Marker position={loc} {...markerProps} />
              </GoogleMap>
            </LoadScript>
          ) : (
            <LoadScript googleMapsApiKey={mapApiKey}>
              <GoogleMap
                center={loc}
                mapContainerStyle={{
                  width: "100%",
                  height: "60vh",
                }}
                options={{ mapId: mapId }}
              >
                <StreetViewPanorama
                  options={{
                    position: loc,
                    visible: true,
                  }}
                />
              </GoogleMap>
            </LoadScript>
          )}{" "}
        </div>
      )}
    </div>
  );
};
export default ListingMap;
